import { render, staticRenderFns } from "./selectTransfer.vue?vue&type=template&id=5b3583dc&scoped=true&"
import script from "./selectTransfer.vue?vue&type=script&lang=js&"
export * from "./selectTransfer.vue?vue&type=script&lang=js&"
import style0 from "./selectTransfer.vue?vue&type=style&index=0&id=5b3583dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3583dc",
  null
  
)

export default component.exports